import { render, staticRenderFns } from "./service_usage.vue?vue&type=template&id=49e496d7&scoped=true"
import script from "./service_usage.vue?vue&type=script&lang=js"
export * from "./service_usage.vue?vue&type=script&lang=js"
import style0 from "./service_usage.vue?vue&type=style&index=0&id=49e496d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e496d7",
  null
  
)

export default component.exports